// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_a99348a","modalFade":"_675a164","modal":"_5bb6a3d","dialog":"_f68d324"};